import { render, staticRenderFns } from "./TransactionTab.vue?vue&type=template&id=4b2719bb&scoped=true"
import script from "./TransactionTab.vue?vue&type=script&lang=js"
export * from "./TransactionTab.vue?vue&type=script&lang=js"
import style0 from "./TransactionTab.vue?vue&type=style&index=0&id=4b2719bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2719bb",
  null
  
)

export default component.exports